/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Image_AltInputs */

const en_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft drawing a dimensioned mounting plate, with the command line, drafting tools and layer properties visible`)
};

/**
* | output |
* | --- |
* | "CADCraft drawing a dimensioned mounting plate, with the command line, drafting tools and layer properties visible" |
*
* @param {Home_Hero_Image_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_image_alt = /** @type {((inputs?: Home_Hero_Image_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Image_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_image_alt(inputs)
});
export { home_hero_image_alt as "home.hero.image_alt" }